"use strict";

exports.__esModule = true;
exports.ErrorText = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ErrorText = exports.ErrorText = _styledComponents["default"].div.withConfig({
  displayName: "ErrorText",
  componentId: "sc-11p4916-0"
})(["display:flex;justify-content:center;align-items:center;width:", "px;height:", "px;font-size:17px;font-weight:500;"], function (props) {
  return props.width;
}, function (props) {
  return props.height;
});